var _path, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgMv = function SvgMv(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 720 480"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D21034",
    d: "M0 0h720v480H0z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#007E3A"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M120 120h480v240H120z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FFF",
    cx: 390,
    cy: 240,
    r: 80
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 420,
    cy: 240,
    r: 80
  }))));
};

export default SvgMv;